import { createRouter, createWebHistory } from "vue-router";
import loginPage from "../pages/login.vue";

import adminLayout from "../layouts/admin.vue";

import masterView from "../views/masterdealer/index.vue";
import retailersView from "../views/retailers/index.vue";
import productsView from "../views/products/index.vue";
import billersView from "../views/billers/index.vue";
import transactionsView from "../views/transactions/index.vue";
import bayadTransactionsView from "../views/bayadTransactions/index.vue";
import topupView from "../views/topup/index.vue";
import ratesView from "../views/rates/index.vue";
import subRetailerView from "../views/subRetailersView/index.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: loginPage,
  },
  {
    path: "/",
    name: "adminLayout",
    component: adminLayout,
    children: [
      {
        path: "master",
        name: "Wallet Balance",
        component: masterView,
        meta: { role: "admin" },
      },
      {
        path: "retailers",
        name: "Master Dealer",
        component: retailersView,
        meta: { role: "admin" },
      },
       {
        path: "subRetailers",
        name: "SubRetailers",
        component: subRetailerView,
        meta: { role: "retailer" },
      },
      {
        path: "products",
        name: "Products",
        component: productsView,
        meta: { role: "admin" },
      },
      {
        path: "billers",
        name: "Billers",
        component: billersView,
        meta: { role: "admin" },
      },
      {
        path: "transactions",
        name: "Transactions",
        component: transactionsView,
      },
      {
        path: "bayad-transactions",
        name: "BayadTransactions",
        component: bayadTransactionsView,
      },
      {
        path: "topup",
        name: "Topup",
        component: topupView,
      },
      {
        path: "rates",
        name: "Rates",
        component: ratesView,
        meta: { role: "admin" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

import store from "../store";

//prevents non admin user from accessing non admin routes
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("_ssid");

  if (!token) {
    // no session
    if (to.name != "Login" && to.name != "Master") {
      // if also not heading to default path head tehre
      return next({ name: "Login" });
    }
  } else {
    try {
      await store.dispatch("adminController/GetAdminInfo");
      const user = store.getters["adminController/admin"];

      if (to.meta?.role && user.role !== to.meta.role) {
        return next({ name: "Retailers" });
      }
    } catch (err) {
      console.error("Error during route check:", err);
      if (to.name != "Login") {
        next({ name: "Login" });
      }
    }
  }

  return next();
});

export default router;
